// extracted by css-extract-rspack-plugin
export default {"mappedColumns":"mappedColumns-gTlPwy","arrowIcon":"arrowIcon-RkTayj","columnList":"columnList-sSZb4p","columnRow":"columnRow-MvNalv"};